import { ActivityType, NotificationStatus, NotificationType } from 'enums';
import { useMutateNotification, useSearchNotification } from 'hooks';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export function useHandleRemarkingUpdateEmailSent() {
  const { partialSubmission, logSubmissionActivity } = useSubmissionsWorkspace();
  const { items: notifications } = useSearchNotification({
    filter: {
      submissionId: partialSubmission?.id,
    },
    enabled: !!partialSubmission,
  });
  const { updateNotification } = useMutateNotification();
  const remarkingUpdateNotification = notifications.find(
    (notification) =>
      notification.type === NotificationType.RemarketUpdate && notification.status === NotificationStatus.New,
  );

  return async () => {
    await logSubmissionActivity({ activityType: ActivityType.CustomerEmailSent });
    if (remarkingUpdateNotification) {
      await updateNotification.mutateAsync({
        id: remarkingUpdateNotification.id,
        data: { status: NotificationStatus.Completed },
      });
    }
  };
}
